import React from 'react';
import { Link } from '@lt/components';
import { i18n } from '@lt/localization';
import styles from './emailButton.module.css';

import { mapEmailToConfig } from './utils';
import { TEST_ID_EMAIL_LINK_CONTAINER } from './constants';

interface Props {
  email: string;
}

export const EmailButton: React.FC<Props> = ({ email }) => {
  const config = mapEmailToConfig(email);

  if (!config) {
    return null;
  }

  return (
    <Link
      className={styles.link}
      href={config.url}
      data-testid={TEST_ID_EMAIL_LINK_CONTAINER}
    >
      {config.icon}
      <span className={styles.text}>
        {i18n.t('emailButton.title', { ns: 'auth', name: config.name })}
      </span>
    </Link>
  );
};
